export default "__VITE_ASSET__ba8a6c5d__"